const actions = {
    clear({ commit }) {
        return new Promise((resolve) => {
            const customer = JSON.parse(localStorage.getItem('customer'))

            localStorage.clear()

            commit('clear', customer)

            resolve(customer)
        })
    },
    setAutenticacao({ commit }, autenticacao) {
        localStorage.setItem('autenticacao', JSON.stringify(autenticacao))
        commit('setAutenticaco', autenticacao)
    },
    setCentroCusto({ commit }, centroCusto) {
        localStorage.setItem('centro_custo', JSON.stringify(centroCusto))
        commit('setCentroCusto', centroCusto)
    },
    setCliente({ commit}, cliente) {
        localStorage.setItem('cliente', JSON.stringify(cliente))
        commit('setCliente', cliente)
    },
    setCustomer({ commit }, customer) {
        return new Promise(resolve => {
            localStorage.setItem('customer', JSON.stringify(customer))
            commit('setCustomer', customer)

            resolve(customer)
        })
    },
    setLoading({ commit }) {
        commit('setLoading')
    },
    setLotacao({ commit }, lotacao) {
        localStorage.setItem('lotacao', JSON.stringify(lotacao))
        commit('setLotacao', lotacao)
    },
    setMenu({ commit }, menu) {
        localStorage.setItem('menu', JSON.stringify(menu))
        commit('setMenu', menu)
    },
    setShowExitFormConfirmation({ commit }) {
        commit('setShowExitFormConfirmation')
    },
    setSidebar({commit}, value) {
        localStorage.setItem('sidebar', value)
        commit('setSidebar', value)
    },
    unsetLoading({ commit }) {
        commit('unsetLoading')
    },
    unsetShowExitFormConfirmation({ commit }) {
        commit('unsetShowExitFormConfirmation')
    },
}

export default actions